import CustomersContainer from '../CustomerList/containers/CustomersContainer'
import CategoryContainer from '../../containers/Category/CategoriesContainer'

// Sync route definition
export default {
  components: { main: CustomersContainer, category: CategoryContainer },
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js